import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const LocationFiltersBlock = styled.div`
  position: relative;
  padding-left: 24px;

  > svg {
    position: absolute;
    top: 15px;
    left: 0;
    color: ${({ theme }) => theme.mainColor};
  }

  ${maxMediaQueries.phablet`
    width: 100%;
  `};
`;
